<script setup>
  import { useI18n } from 'vue-i18n';
  import { useCartCommentStore } from '../../stores/CartCommentStore.js';

  // FBKS-2718: footer shortcut to the comments panel
  const { t } = useI18n();
  const commentStore = useCartCommentStore();

  const scrollToComments = () => document.getElementById('cart-comments')?.scrollIntoView({ behavior: 'smooth' });
</script>

<template>
  <button type="button" class="btn btn-outline-primary btn-sm rounded-pill" @click="scrollToComments">
    <i class="bi bi-chat-left-text" aria-hidden="true"></i>
    {{ t('cart.comments.footer', { count: commentStore.count }) }}
    <template v-if="commentStore.unreadCount"> · {{ t('cart.comments.new_count', commentStore.unreadCount, { count: commentStore.unreadCount }) }}</template>
  </button>
</template>
